import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../config/firebase";

/**
 * Server-side auto-join: finds an organization whose lead has an active
 * subscription and shares the same email domain as the user.
 *
 * @param {{ uid: string, email: string }} params
 * @returns {Promise<{ success: boolean, organizationId?: string, reason?: string, alreadyMember?: boolean, error?: string }>}
 */
export const joinOrganizationByEmailDomain = async ({ uid, email }) => {
  if (!uid || !email) {
    return { success: false, reason: "missing_params" };
  }

  try {
    const functions = getFunctions(app, "europe-west1");
    const callable = httpsCallable(functions, "joinOrganizationByEmailDomain");
    const result = await callable({});
    return result.data;
  } catch (error) {
    console.error("joinOrganizationByEmailDomain:", error);
    return {
      success: false,
      reason: "error",
      error: error?.message || "Unknown error",
    };
  }
};

export default joinOrganizationByEmailDomain;
